<template lang="pug">
  .mobile-menu(v-if="header", :class="{'mobile-menu--show': menuShow}")
    .mobile-menu__content
      .mobile-menu__content-logo-wr
        router-link.mobile-menu__content-logo(to="/", @click.native="closeMenuLocal()")
          img.mobile-menu__content-logo-img(v-if="header.logo", :src="header.logo" alt = '')

      .mobile-menu__content-items-wr
        .mobile-menu__content-items(v-if="header.menu")
          router-link.mobile-menu__content-item(v-for="item in header.menu", :to="item.link", :key="item.id", @click.native="closeMenuLocal()")
            | {{item.title}}

        .mobile-menu__content-info
          a.mobile-menu__phone(v-if="header.phone", :href="header.phone.link", v-html="header.phone.title")
          .mobile-menu__address(v-if="header.address", v-html="")
            SvgIcon.mobile-menu__address-ico(name="marker", width="16", height="16")
            | {{header.address}}
          .mobile-menu__time(v-if="header.time")
            SvgIcon.mobile-menu__time-ico(name="clock", width="16", height="16")
            | {{header.time}}
          .mobile-menu__time(v-if="footer && footer.email", :href="footer.email.link")
            SvgIcon.mobile-menu__time-ico(name="mail", width="16", height="16")
            | {{footer.email.title}}
          .mobile-menu__socials(v-if="footer && footer.socials")
            a.mobile-menu__socials-item(v-for="item in footer.socials", :href="item.link", :key="item.id", target="_blank")
              SvgIcon.mobile-menu__socials-item-ico(:name="item.icon", width="40", height="40")

</template>

<script>
  import '@/components/common/mobileMenu/mobileMenu.styl';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import EventBus from '@/eventBus';

  export default {
    name: 'MobileMenu',

    data() {
      return {
        menuTop: null,
        header: null,
        footer: null,

        menuShow: false
      }
    },

    components: {
      SvgIcon
    },

    created() {
      // Данные страницы загружены
      EventBus.$on('pageLoaded', res => {
        let path = this.$route.path || '';

        if(res.menuTop) {
          this.menuTop = res.menuTop;
        }

        if(res.header) {
          this.header = res.header;
        }

        if(res.footer) {
          this.footer = res.footer;
        }

        this.$nextTick(() => {
          this.initScroll();
          this.setInitialActiveClass(path);
        });
      });

      EventBus.$on('closeMobileMenu', res => {
        this.closeMenu();
      });

      EventBus.$on('showMobileMenu', res => {
        this.showMenu();
      });

      this.$nextTick(() => {
        this.setActiveClass();
      });

      //this.$nextTick(() => {
      //  $(document).on('click', '.js-PrologueUniRu__mobileMenu-nav-lnk-nested-top', function() {
      //    var $parent = $(this).parents('.PrologueUniRu__mobileMenu-nav-lnk-nested');
      //
      //    $parent.toggleClass('PrologueUniRu__mobileMenu-nav-lnk-nested--open');
      //
      //    $parent.find('.PrologueUniRu__mobileMenu-nav-lnk-nested-bottom').slideToggle();
      //  });
      //});
    },

    methods: {
      closeMenu() {
        this.menuShow = false;
      },

      showMenu() {
        this.menuShow = true;
      },

      initScroll() {
        if($('.mobile-menu__content-items-wr').length) {
          new PerfectScrollbar($('.mobile-menu__content-items-wr')[0], {
            wheelSpeed: 0.25,
            wheelPropagation: true,
            minScrollbarLength: 20,
            maxScrollbarLength: 150
          });
        }
      },

      closeMenuLocal() {
        this.closeMenu();

        $('.burger').removeClass('burger--show');
      },

      setInitialActiveClass(path) {
        let pathArr = path.split('/');

        $('.mobile-menu__content-item').removeClass('mobile-menu__content-item--active');

        if(pathArr[1].length) {
          $(`.mobile-menu__content-item[href*='${pathArr[1]}']`).addClass('mobile-menu__content-item--active');
        } else {
          $('.mobile-menu__content-item').removeClass('mobile-menu__content-item--active');
        }
      },

      setActiveClass() {
        $(document).on('click', '.mobile-menu__content-item', function() {
          $('.mobile-menu__content-item').filter('.mobile-menu__content-item--active').removeClass('header__menu-item--active');

          $(this).addClass('mobile-menu__content-item--active');
        });

        $(document).on('click', '.header__cart', function() {
          $('.mobile-menu__content-item').removeClass('mobile-menu__content-item--active');
        });
      },
    }

  }
</script>
